import { gql } from '@apollo/client';

export const ALL_INPUT_CATEGORIES = gql`
  query AllInputCategories {
    inputCategories: getInputCategories {
      id
      name
    }
  }
`;
